import {POST} from "@/services/gateway";

const listBackups = ({pagination, sharedDriveIds, filter}) => {
  return POST('backup/list', {pagination, sharedDriveIds, filter})
}

export {
  listBackups
}
